import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { css } from '@emotion/core';
import { FLEX_ROW } from '../../layout/flexBox';
import { Str } from '../../localization/translationKeys';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Z_INDEX } from '../../globalStyle/zIndex';
import { COLORS } from '../../globalStyle/colors';
import { btnStyle } from '../../forms/styles/button';
import MobileToolbarBtn from '../../localization/MobileToolbarBtn';


const styles = {
  root:   css`
    justify-content: flex-end;
    width: 100vw;
    height: 72px;
    position: fixed;
    bottom: 0;
    z-index: ${Z_INDEX.MOBILE_TOOLBAR};
    background-color: ${COLORS.WHITE};
  `,
  button: css`
    font-size: 9px;
    border-radius: 0;
    flex-basis: 80px;
    border-color: transparent;
    height: 72px;
    line-height: normal;
    & > span {
      overflow-wrap: break-spaces;
      text-transform: uppercase;
    }
  `,
};


type Props = {
  className?: string;
  allAnswered: boolean;
  languageId: number;
  openSendGoalsModal: () => void;
}


/**
 * MobileSetGoalsActionsBar: a tool bar which houses the action button associated with the set goals flow on mobile
 * screens.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const MobileSetGoalsActionsBar: React.FC<Props> = props => (
  ReactDOM.createPortal(
    <div css={[FLEX_ROW, styles.root]}>
      <MobileToolbarBtn
        css={[btnStyle.primary(COLORS.GREEN), styles.button]}
        str={Str.EmailGoals}
        icon={faEnvelope}
        onClick={props.openSendGoalsModal}
        disabled={!props.allAnswered}
      />
    </div>
    ,
    document.getElementById('root') || document.getElementById('react-root') || document.body,
  )
);

export default MobileSetGoalsActionsBar;
